__turbopack_context__.v({
  "close": "TypeRef-module__i079-G__close",
  "content": "TypeRef-module__i079-G__content",
  "fallback": "TypeRef-module__i079-G__fallback",
  "header": "TypeRef-module__i079-G__header",
  "link": "TypeRef-module__i079-G__link",
  "popup": "TypeRef-module__i079-G__popup",
  "scrollArea": "TypeRef-module__i079-G__scrollArea",
  "trigger": "TypeRef-module__i079-G__trigger",
});
